module.exports = __webpack_public_path__ + "img/banner_square.32525f16.png";